import type { CitationStyle } from '@/features/common/types/CitationStyle';

/** The two styles FR-021 asks for, in the order a reader is most likely to want them. */
export const CITATION_STYLES = ['ISO690', 'APA'] as const;

const CITATION_STYLE_LABELS: Record<CitationStyle, string> = {
  ISO690: 'ISO 690',
  APA: 'APA',
};

/** Whether a style code from the server is one of CITATION_STYLES — it arrives as a string. */
export function isCitationStyle(code: string): code is CitationStyle {
  const known: readonly string[] = CITATION_STYLES;
  return known.includes(code);
}

/** The style's own name ("ISO 690"); a style this file does not know is shown as its code. */
export function citationStyleLabel(style: string): string {
  return isCitationStyle(style) ? CITATION_STYLE_LABELS[style] : style;
}
